/* libs/oyan-ui/src/lib/components/layout/header/header.component.scss */
:host .no-margin {
  margin: 0 !important;
}
.business-profile-select {
  padding-right: 20px;
  display: flex;
  justify-content: flex-end;
}
img {
  height: 40px !important;
}
/*# sourceMappingURL=header.component.css.map */
